module.exports = __webpack_public_path__ + "img/1.bf890b12.png";